import "./SearchByView.css";

import { Dispatch, SetStateAction } from "react";

import { SearchBy } from "../../../models/fineModels";
import { setSearchBy } from "../../../store/fine/fineActions";
import { useAppDispatch } from "../../../hooks/reduxHooks";
import { useEffect } from "react";

interface SearchByViewProps {
  setErrorMessage: Dispatch<SetStateAction<string | null>>;
  urlNo: string | null;
}

const SearchByView = ({ setErrorMessage, urlNo }: SearchByViewProps) => {
  useEffect(() => {
    if (urlNo) dispatch(setSearchBy(SearchBy.INFRINGEMENT_NUMBER));
  }, []);

  const dispatch = useAppDispatch();
  const setSearchType = (val: SearchBy) => {
    setErrorMessage(null);
    if (val) {
      dispatch(setSearchBy(val));
    }
  };
  return (
    <>
      <p>Search fines by</p>
      <div className="search-by-button-container">
        <div onClick={() => setSearchType(SearchBy.ID_NUMBER)}>ID Number</div>
        <div onClick={() => setSearchType(SearchBy.INFRINGEMENT_NUMBER)}>
          Traffic Notice Number
        </div>
      </div>
    </>
  );
};

export default SearchByView;
